module.exports = __webpack_public_path__ + "static/media/S3N13-2.0a1817cc.svg";